import React from "react";
import MainLayout from "../MainLayout";
import PaymentDeduction from "../../common/MainContent/Payroll/Paystubs/PaymentDeductions";

const PayrollPaymentDeductionPage = (props) => <MainLayout component={PaymentDeduction} />;

export default PayrollPaymentDeductionPage;
